import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

import { TaskSelectorComponent } from './task-selector.component';

@NgModule({
  imports: [CommonModule, FormsModule, SelectModule],
  declarations: [TaskSelectorComponent],
  exports: [TaskSelectorComponent],
})
export class TaskSelectorModule {}
